














































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { ACTION } from "./";
import AddEditLicenseDialog from "./AddEditLicenseDialog.vue";
import { Dictionary } from "lodash";
import {
  LicensesApi,
  LicensesApiGetLicensesByKeywordRequest,
} from "../../../apis";
import moment from "moment";
import { DataOptions, DataTableHeader } from "vuetify";
import VueI18n from "vue-i18n";
import ConfirmDialog from "../common/ConfirmDialog.vue";

@Component({
  components: { MoreVertBtn, AddEditLicenseDialog, ConfirmDialog },
})
export default class LicenseList extends Vue {
  status = "All";
  keywords = "";
  fromOpenDate = "";
  toOpenDate = "";
  isShowLicenseDialog = false;
  selectedLicense = {} as any;
  mode: ACTION = null;
  dataLicense = [];
  showLicenseKey = false;

  statusOptions = [
    { value: "", name: this.$t("text.all") },
    { value: "Waiting", name: this.$t("text.Waiting") },
    { value: "Activated", name: this.$t("text.Activated") },
    { value: "Deactivated", name: this.$t("text.Deactivated") },
  ];
  pagingOption: DataOptions | null = null;
  totalRecord: number = 0;

  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;

  searchParam: any = {
    status: "",
  };

  selectedAction: ACTION;

  readonly EDIT_EMAIL_ACTION: IAction = {
    titleName: this.$t("text.edit"),
    action: ACTION.EDIT_LICENSE,
    permission: { context: "LICENSE_LIST", action: "update" },
  };

  readonly DELETE_EMAIL_ACTION: IAction = {
    titleName: this.$t("text.delete"),
    action: ACTION.DELETE_LICENSE,
    titleStyle: "color: red",
    permission: { context: "LICENSE_LIST", action: "delete" },
  };

  get actions(): Array<IAction> {
    return [this.EDIT_EMAIL_ACTION, this.DELETE_EMAIL_ACTION];
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.customer"),
        value: "customer.companyName",
      },
      {
        text: this.$t("text.location"),
        value: "location.locationName",
      },
      {
        text: this.$t("text.licenseNumber"),
        value: "licenseKey",
      },
      {
        text: this.$t("text.isSendOfflineMail"),
        value: "isSendOfflineMail",
      },
      {
        text: this.$t("text.registrationDate"),
        value: "registrationDate",
      },
      {
        text: this.$t("text.expirationDate"),
        value: "expirationDate",
      },
      {
        text: this.$t("text.action"),
        value: "action",
        sortable: false,
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get addLicenseClick() {
    return this.$store.getters.addLicenseClick;
  }

  onPagingOption() {
    this.doSearch();
  }

  async doSearch() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const registrationDate = this.searchParam.registrationDate
      ? moment(this.searchParam.registrationDate, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const expirationDate = this.searchParam.expirationDate
      ? moment(this.searchParam.expirationDate, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const body: LicensesApiGetLicensesByKeywordRequest = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      status: getValueOrUndefined(this.searchParam.status),
      registrationDate: registrationDate,
      expirationDate: expirationDate,
      limit: this.pagingOption.itemsPerPage,
      page: this.pagingOption.page,
      orderBy: getValueOrUndefined(this.pagingOption.sortBy[0]),
      orderDesc: getValueOrUndefined(this.pagingOption.sortDesc[0]),
    };
    try {
      this.$util.showLoading();
      const res = await new LicensesApi().getLicensesByKeyword(body);
      this.dataLicense = res.data.data;
      this.totalRecord = res.data.count;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  @Watch("addLicenseClick")
  onaddLicenseClickWatch() {
    this.mode = ACTION.NEW_LICENSE;
    this.selectedLicense = {};
    this.isShowLicenseDialog = true;
  }

  getActionByStatus(status: string): Array<IAction> {
    switch (status) {
      case "Waiting": {
        return [this.EDIT_EMAIL_ACTION, this.DELETE_EMAIL_ACTION];
      }
      case "Activated":
      case "Deactivated": {
        return [this.EDIT_EMAIL_ACTION];
      }
      default: {
        return [];
      }
    }
  }

  async onSelectedAction(item, action) {
    this.selectedLicense = {
      id: item.id,
      customer: item.customer.id,
      location: item.location.id,
      clientKey: item.clientKey,
      registrationDate: moment(item.registrationDate).format("YYYY-MM-DD"),
      expirationDate: item.expirationDate? moment(item.expirationDate).format("YYYY-MM-DD"): null,
      isSendOfflineMail: item.isSendOfflineMail,
    };
    this.selectedAction = action;
    switch (action) {
      case ACTION.EDIT_LICENSE: {
        this.mode = ACTION.EDIT_LICENSE;
        this.isShowLicenseDialog = true;
        break;
      }
      case ACTION.DELETE_LICENSE: {
        this.showConfirmDialog = true;
        this.confirmContent = this.$t("dialog.delete.license");
        break;
      }
      default: {
        break;
      }
    }
  }
  copy(key){
    window.navigator['clipboard'].writeText(key);
  }
  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE_LICENSE) {
      this.doDelete();
    }
  }

  async doDelete() {
    try {
      this.$util.showLoading();
      await new LicensesApi().deleteLicense({
        id: this.selectedLicense.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.doSearch();
      this.$util.hideLoading();
    }
  }

  onViewLicenseKeyAction(selectedLicense) {
    this.showLicenseKey = true;
    this.selectedLicense = selectedLicense;
  }
}
